var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
var __WEBPACK_NAMESPACE_OBJECT__ = x({ ["default"]: () => __WEBPACK_EXTERNAL_MODULE_react_syntax_highlighter_dist_esm_styles_hljs_nord_5bfa1099__["default"] });